<template>
  <div class="main-content mt-100">
    <!-- Divider: Contact -->
    <section class="divider" v-if="program != null">
      <div class="container">
        <div class="row" v-if="!paymentCompleted">
          <div class="col-md-3">
            <div class="item">
              <div
                class="class-item box-hover-effect effect1 mb-md-30 bg-lighter"
              >
                <div class="content text-left flip p-25">
                  <h4 class="text-uppercase font-weight-800 line-bottom">
                    {{ program.Title }}
                  </h4>
                  <p>{{ program.Description }}</p>
                  <b
                    >Il programma sarà disponibile per 35 giorni dalla data di
                    acquisto</b
                  >
                </div>
                <div class="thumb" v-if="program.MainImage">
                  <img
                    :alt="program.MainImage.alternativeText"
                    :src="baseUrl + program.MainImage.url"
                    class="img-responsive img-fluid img-fullwidth"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-9" v-if="!alreadyBuyed">
              
            <div
              class="font-18 mt-0 mb-30 no-style markdown-link"
              v-if="program.CrossSellingText"
            >
              <vue-markdown :source="program.CrossSellingText"></vue-markdown>
            </div>

            <div class="option-block" v-if="program.program_option">
              <h4>Seleziona un'opzione di acquisto:</h4>

              <div class="portfolio-filter option-filter">
                <span
                  v-for="programOption in program.program_option
                    .ProgramOptionMonth"
                  :key="programOption.id"
                >
                  <a
                    v-bind:class="{ active: programOption.isSelected }"
                    v-on:click="programOptionClicked(programOption.id)"
                  >
                    {{ programOption.Title }} - {{ programOption.Price }}€
                  </a>
                </span>
              </div>
              <hr />
            </div>
        
            <h2>
              Prezzo:
              <span v-if="!couponApplied" class="text-theme-colored"
                >{{ program.Price }}€</span
              >
              <span v-if="couponApplied" class="text-line-through"
                >{{ program.BasePrice }}€</span
              >
              <span v-if="couponApplied" class="text-theme-colored">
                {{ program.Price }}€</span
              >
            </h2>

            <a
              data-parent="#accordionDiscountCode"
              data-toggle="collapse"
              aria-expanded="true"
              class="text-theme-colored text-underline"
              :href="'#accordionDiscountCodePanel'"
              >Hai un codice sconto?</a
            >

<div
      :key="`pp-msg-${program && program.Price}`"
      ref="paypalMessage"
            class="mt-20"
    data-pp-message
    data-pp-style-layout="text"
    data-pp-style-logo-type="primary"
    data-pp-style-text-color="black">
</div>


            <div
              :id="'accordionDiscountCodePanel'"
              class="panel-collapse collapse"
              role="tablist"
              aria-expanded="true"
            >
              <div class="discountCodePanel mt-20">
                <div class="row">
                  <div class="form-group col-md-6">
                    <label>Inserisci qui il tuo codice sconto</label>
                    <div class="discountCode mt-10">
                      <input
                        type="text"
                        v-model="couponCode"
                        required
                        class="form-control"
                      />
                      <a
                        v-bind:class="{ disabled: couponCode == '' }"
                        v-on:click.stop.prevent="applyCouponCode()"
                        class="ml-20 btn-buy btn btn-dark btn-theme-colored btn-xl"
                        >APPLICA</a
                      >
                    </div>
                  </div>
                </div>

                <div class="row" v-if="errorOnCoupon">
                  <div class="form-group col-md-6">
                    <div class="alert alert-danger">
                      Il codice sconto non è valido
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />

            <paypal-form
              v-bind:amount="program.Price"
              v-bind:discountCode="couponCode"
              v-bind:IdProgram="program.id"
              v-bind:MonthsSelected="monthSelected"
              v-bind:userinfo="userInfo"
              @paymentNotCompleted="paymentNotCompleted"
              v-on:paymentCompleted="paymentCompleted = true"
            />

            <div v-if="userAlreadyExistError">
              <div class="alert alert-danger" role="alert">
                Questa mail è già utilizzata, accedi al tuo account e procedi
                con il pagamento
              </div>
            </div>
            <div v-if="genericError">
              <div class="alert alert-danger" role="alert">
                C'è stato un'errore imprevisto nel pagamento. Ti preghiamo di
                riprovare
              </div>
            </div>
          </div>
          <div class="col-md-9" v-if="alreadyBuyed">
            <h2>
              Il prodotto è già stato acquistato, vai nella tua area personale
              per visualizzare i dettagli
            </h2>
          </div>
        </div>
        <div class="row" v-if="paymentCompleted">
          <div class="col-md-12 t-a-center">
            <h2>
              Il processo di pagamento è andato a buon fine
              <br />
              <span class="text-theme-colored"
                >Accedi e inizia ad allenarti</span
              >
            </h2>
            <a
              :href="'/dashboard'"
              class="btn btn-dark btn-theme-colored btn-xl"
            >
              <b>ACCEDI</b>
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
.discountCode {
  display: flex;
  align-items: center;
  justify-content: center;
}

.text-line-through {
  text-decoration: line-through;
}

.item .class-item{
  border-radius: 5px;
}

a.btn.disabled {
  background-color: #b3b3b3;
  border-color: #b3b3b3;
}
</style>

<script>

//COMPONENT FOR PAYPAL
import axios from "axios";
import VueMarkdown from "vue-markdown";
import PaypalForm from "../components/PaypalForm.vue";

export default {
  name: "Payment",
  props: ["ID"],
  data() {
    return {
      program: null,
      monthSelected: 1,
      baseUrl: process.env.VUE_APP_API_URL,
      loggedIn:
        localStorage.getItem("token") != undefined ||
        localStorage.getItem("token") != null,
      alreadyBuyed: false,
      paymentCompleted: false,
      userAlreadyExistError: false,
      genericError: false,
      couponCode: "",
      couponApplied: false,
      errorOnCoupon: false,
      userInfo: null,
    };
  },
  methods: {
    renderPayPalMessage() {
      this.$nextTick(() => {
        if (!this.program || !window.PayPalSDK || !window.PayPalSDK.Messages) {
          return;
        }

        const messageContainer = this.$refs.paypalMessage;
        if (!messageContainer) {
          return;
        }

        const amount = Number(this.program.Price);
        if (!Number.isFinite(amount)) {
          return;
        }

        messageContainer.innerHTML = "";
        window.PayPalSDK.Messages({
          amount,
          style: {
            layout: "text",
            logo: { type: "primary" },
            text: { color: "black" },
          },
        }).render(messageContainer);
      });
    },
    programOptionClicked(idProgramOption) {
      this.program.program_option.ProgramOptionMonth.forEach((x) => {
        x.isSelected = idProgramOption == x.id;

        if (x.isSelected) {
          this.monthSelected = x.Month;
          this.program.Price = x.Price;
          this.program.BasePrice = this.program.Price;
        }
      });

      this.program.program_option.ProgramOptionMonth = Object.assign(
        [],
        this.program.program_option.ProgramOptionMonth
      );

      

      this.couponApplied = false;
      this.couponCode = "";
    },
    applyCouponCode() {
      let obj = {
        couponCode: this.couponCode,
        price: this.program.BasePrice,
        programID: this.program.id,
      };

      axios
        .post(process.env.VUE_APP_API_URL + "/checkDiscountCode", obj)
        .then((response) => {
          if (response.data.FinalPrice) {
            this.program.Price = response.data.FinalPrice;
            this.couponApplied = true;
            this.errorOnCoupon = false;
          } else {
            this.couponApplied = false;
            this.errorOnCoupon = true;
            this.program.Price = this.program.BasePrice; 
          }
        })
        .catch(() => {
          console.log("ERROR");
          this.couponApplied = false;
          this.errorOnCoupon = true;
            this.program.Price = this.program.BasePrice;
        });
    },
    paymentNotCompleted(errorValue) {
      if (errorValue == "USER_ALREADY_EXIST") {
        this.userAlreadyExistError = true;
      } else {
        this.genericError = true;
      }
    },
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_API_URL + "/programs/" + this.ID)
      .then((response) => {
        //SE SONO PRESENTI PIù OPZIONI, PRESELEZIONO LA PRIMA OPZIONE DISPONIBILE
        if (response.data.program_option) {
          response.data.program_option.ProgramOptionMonth[0].isSelected = true;
        }

        this.program = response.data;
        console.log(this.program);
        if (!this.program.IsVisible) {
          window.location.replace("/");
        }

        this.program.BasePrice = this.program.Price;
        this.renderPayPalMessage();

        //VERIFICO SE HO GIA IL PROGRMMA
        if (this.loggedIn) {
          axios
            .get(process.env.VUE_APP_API_URL + "/user/getAccountInfo")
            .then((response) => {
              if(response.data.userInfo != null){
              this.userInfo = response.data.userInfo;
            }
            axios
            .get(process.env.VUE_APP_API_URL + "/user/getinfo")
            .then((response) => {
              this.alreadyBuyed = response.data.CompletePrograms.some(
                (x) => x.id == this.program.id
              );
            });
            });
        

           
        }
      });
  },
  watch: {
    "program.Price": function () {
      this.renderPayPalMessage();
    },
  },
  components: {
    "paypal-form": PaypalForm,
    VueMarkdown,
  },
};
</script>